import { setLocale } from "yup";
import { splitPath } from "./utils";

setLocale({
  mixed: {
    required: ({ path }) => `${splitPath(path)} can't be blank.`
  },
  string: {
    email: "Invalid email",
    min: ({ min }) => `Minimum ${min} characters.`
  },
  array: {
    min: ({ path }) => `${splitPath(path)} can’t be empty.`
  },
  number: {
    positive: ({ path }) => `${splitPath(path)} must be positive.`
  }
});
